import { GET_AUTH } from '@/services/api/auth'
import { client } from '@/services/apolloclient'
import store from '@/state/store'
import { Exception } from 'sass'

export const Auth = {
  methods: {
    async getAuth () {
      await client
        .query({
          fetchPolicy: 'no-cache',
          query: GET_AUTH
        })
        .then(({ data }) => {
          if (data.auth.isSuccessful) {
            store.commit('access/SET_DATA', data.auth.auth)
          } else {
            throw Exception('Not Authorized')
          }
        })
        .catch((err) => {
          if (err) {
            location.href = `${process.env.BASE_URL}logout`
          }
        })
    }
  }
}
